import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL, pricing } from '../data/sushiContent';
import { trackPixelEvent } from '../utils/metaPixel';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 240);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <AnimatePresence data-id="element-251" data-mp="3ubak06nji4o6">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-champagne/25 bg-charcoal-950/95 px-3 pb-[max(0.625rem,env(safe-area-inset-bottom))] pt-2.5 backdrop-blur lg:hidden" data-id="element-252" data-mp="3uegc7urgtmo4">
          <div className="mx-auto flex max-w-xl items-center gap-3" data-id="element-253" data-mp="75vqx9uhkj86">
            <div className="shrink-0 leading-none" data-id="element-254" data-mp="765giwbmcodc">
              <p className="font-display text-xl font-semibold text-ivory-50" data-id="element-255" data-mp="27ayhwlh73ua">
                {pricing.today}
                <span className="ml-1 align-middle font-sans text-[9px] font-semibold uppercase tracking-[0.12em] text-muted" data-id="element-256" data-mp="gwqpndox5bai">
                  USD
                </span>
              </p>
              <p className="mt-1 text-[9px] uppercase tracking-[0.12em] text-muted" data-id="element-257" data-mp="pvlwmrzsepev">
                <span className="line-through" data-id="element-258" data-mp="lv1wrgntx7p1">{pricing.regularPrice}</span>
              </p>
            </div>
            <a href={CHECKOUT_URL} onClick={() => trackPixelEvent('InitiateCheckout', {
          content_name: 'SUSHI FACIL EN CASA',
          value: 17,
          currency: 'USD'
        })} className="flex min-w-0 flex-1 items-center justify-center rounded-full bg-champagne px-3 py-3 text-center text-[11px] font-semibold uppercase leading-none tracking-[0.1em] text-charcoal-950 transition-colors duration-150 ease-out active:bg-champagne-light" data-id="element-259" data-mp="zv2wutw9sb3g">
              Quiero acceso ahora
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}